import _ from 'lodash';
import { getDesktopPagePreset, getBackgroundElementPreset } from 'crazyEditor/core/elements/utils/elementDefinitionUtils';
import { desktopDataFixer, combineChildren, fixZIndex } from './desktopDataFixer';
import { normalizeElementsIfNeeded } from '../shared/sharedDataHandler';
import { PAGE_ELEMENT_ID, BACKGROUND_ELEMENT_ID } from 'crazyEditor/core/elements/utils/elementStaticUtils';

function resolveElements(props) {
  const { elements, elementsFromLocalStorage, oldStructureTemplateData } = props;
  let backgroundElementProps = {};
  let pageElementProps = {};
  let elementsToReturn = {};

  if (!_.isEmpty(elementsFromLocalStorage)) {
    elementsToReturn = elementsFromLocalStorage;
  } else if (!_.isEmpty(elements)) {
    elementsToReturn = elements;
  } else if (oldStructureTemplateData) {
    pageElementProps = oldStructureTemplateData.desktop.PageElement.compProps;
    backgroundElementProps = oldStructureTemplateData.desktop.BackgroundElement.compProps;
    elementsToReturn = oldStructureTemplateData.desktop.elements;
  }

  return {
    elementsToReturn: elementsToReturn,
    pageElementProps: pageElementProps,
    backgroundElementProps: backgroundElementProps
  };
}

function addPageElement(pageElementProps) {
  const pageElementPreset = getDesktopPagePreset();
  if (!_.isEmpty(pageElementProps)) {
    return _.merge({}, pageElementPreset, {
      layout: {
        height: parseInt(pageElementProps.height, 10),
        width: parseInt(pageElementProps.width, 10),
      },
      compProps: {
        background: pageElementProps.background,
        backgroundColor: pageElementProps.backgroundColor,
        backgroundImage: pageElementProps.backgroundImage,
        border: pageElementProps.border || '',
        boxShadow: pageElementProps.boxShadow || '',
        borderRadius: pageElementProps.borderRadius || '',
        fontFamily: pageElementProps.fontFamily,
      }
    });
  }
  return _.assign({}, pageElementPreset);
}

function addBackgroundElement(backgroundElementProps) {
  const backgroundElementPreset = getBackgroundElementPreset();
  if (!_.isEmpty(backgroundElementProps)) {
    return _.assign({}, backgroundElementPreset, {
      compProps: {
        background: backgroundElementProps.background,
        backgroundColor: backgroundElementProps.backgroundColor,
        backgroundImage: backgroundElementProps.backgroundImage,
        border: backgroundElementProps.border || '',
        boxShadow: backgroundElementProps.boxShadow || '',
      }
    });
  }
  return _.assign({}, backgroundElementPreset);
}

function addMissingStaticElementsIfNeeded(staticElements, backgroundElementProps = {}, pageElementProps = {}) {
  if (!staticElements[BACKGROUND_ELEMENT_ID]) {
    staticElements[BACKGROUND_ELEMENT_ID] = addBackgroundElement(backgroundElementProps);
  }
  if (!staticElements[PAGE_ELEMENT_ID]) {
    staticElements[PAGE_ELEMENT_ID] = addPageElement(pageElementProps);
  }
}

function prepareDesktopElements(props) {
  const { elementsToReturn, pageElementProps, backgroundElementProps } = resolveElements(props);
  const { staticElements, elements } = normalizeElementsIfNeeded(elementsToReturn);
  addMissingStaticElementsIfNeeded(staticElements, pageElementProps, backgroundElementProps);
  fixZIndex(elements);
  return {
    staticElements: {
      ..._.mapValues(staticElements, (element) => desktopDataFixer(element))
    },
    elements: combineChildren(_.mapValues(elements, (element) => desktopDataFixer(element)))
  };
}

export {
  prepareDesktopElements
};
